import { render } from "./JzNext.vue?vue&type=template&id=4170382b&scoped=true"
import script from "./JzNext.vue?vue&type=script&lang=js"
export * from "./JzNext.vue?vue&type=script&lang=js"

import "./JzNext.vue?vue&type=style&index=0&id=4170382b&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4170382b"]])

export default __exports__